import React from "react";
import { NavLink, Link } from "react-router-dom";
import LogoutButton from "./LogoutButton";
import { useAuth } from "../context/AuthContext"; // Adjust the path to your AuthContext

const AccountSidebar = () => {
  const { token, isAdmin, logout } = useAuth(); // Access authentication details

  return (
    <div className="hidden lg:block h-screen top-0 left-0 w-1/5 bg-black text-primary font-inter">
      <div className="p-6">
        {/* Breadcrumb */}
        <div className="text-sm mb-8">
          <Link to="/" className="text-primary hover:underline">
            Home
          </Link>
          <span className="text-gray-500"> / </span>
          <span className="text-gray-500">My Account</span>
        </div>

        {/* Sidebar Menu */}
        <div>
          <h2 className="text-lg font-bold mb-6">Manage My Account</h2>
          <nav className="space-y-4">
            <NavLink
              to="/track-order"
              className={({ isActive }) =>
                `block px-4 py-2 flex items-center space-x-2 ${isActive ? "font-bold underline" : "hover:bg-primary hover:text-black"
                }`
              }
            >
              <i className="fas fa-truck"></i>
              <span>My Orders</span>
            </NavLink>
            <NavLink
              to="/manageAccount"
              className={({ isActive }) =>
                `block px-4 py-2 flex items-center space-x-2 ${isActive ? "font-bold underline" : "hover:bg-primary hover:text-black"
                }`
              }
            >
              <i className="fas fa-user-circle"></i>
              <span>My Profile</span>
            </NavLink>

            {/* Admin Link */}
            {isAdmin && (
              <Link
                to="/admin/admin-orderlists"
                className="block px-4 py-2 flex items-center space-x-2 hover:bg-primary hover:text-black"
              >
                <i className="fas fa-cogs"></i>
                <span>Admin</span>
              </Link>
            )}

            <div className="block px-4 py-2 flex items-center space-x-2">
              <LogoutButton onLogout={logout} />
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default AccountSidebar;
